// convenience functions for creating success / failure action names

export const loading = <T extends string>(t: T): `${T}_LOADING` => `${t}_LOADING`
export const success = <T extends string>(t: T): `${T}_SUCCESS` => `${t}_SUCCESS`
export const failure = <T extends string>(t: T): `${T}_FAILURE` => `${t}_FAILURE`
export const reset = <T extends string>(t: T): `${T}_RESET` => `${t}_RESET`
